import Container from "../components/common/Container";
import PageHeader from "../components/common/PageHeader";
import styled from "styled-components";
import { Link } from "react-router";

/**
 * 404.
 *
 * Rota tablosunda `<div>404 NOT FOUND</div>` yazıyordu: çevrilmemiş, stilsiz ve
 * çıkışsız. Yanlış bir URL'ye düşen kullanıcı panelin geri kalanına dönmek için
 * tarayıcının geri düğmesinden başka bir şey bulamıyordu.
 */
const NotFound = () => {
  return (
    <Container>
      <PageHeader
        pageTitle="Sayfa bulunamadı"
        subText="Aradığınız adres taşınmış ya da hiç var olmamış olabilir."
      />
      <Placeholder>
        Adresi elle yazdıysanız kontrol edin. Buraya bir bağlantıdan geldiyseniz
        bağlantı eskimiş olabilir.
        <br />
        <PlaceholderLink to="/dashboard">Özet Rapor'a dön</PlaceholderLink>
      </Placeholder>
    </Container>
  );
};

export default NotFound;

const Placeholder = styled.div`
  border: 1px dashed #d1d5db;
  border-radius: 6px;
  padding: 32px;
  color: #6b7280;
  font-size: 15px;
  line-height: 24px;
  max-width: 720px;
`;

const PlaceholderLink = styled(Link)`
  color: #5c26ff;
  font-weight: 600;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
